import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.scss';

class Spinner extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    className: null,
  };

  render() {
    const { isLoading, children, className } = this.props;
    if (isLoading) {
      return (
        <div className={styles.container}>
          <div className={classNames(styles.loader, className)} />
        </div>
      );
    }
    return children;
  }
}

export function withSpinner(WrappedComponent) {
  function WithSpinner({ isLoading, ...props }) {
    return (
      <Spinner isLoading={isLoading}>
        <WrappedComponent {...props} />
      </Spinner>
    );
  }

  WithSpinner.propTypes = {
    isLoading: PropTypes.bool.isRequired,
  };

  return WithSpinner;
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/app/components/Spinner/index.js